import { Heart, Lock } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="py-12 text-center"
      style={{ backgroundColor: "#F5E6D3" }}
    >
      <div className="max-w-4xl mx-auto px-6">
        <h3
          className="font-serif text-2xl mb-2"
          style={{ color: "#2C2C2C" }}
        >
          Marianna <span className="text-gold">&</span> Marco
        </h3>
        <p className="text-sm mb-4" style={{ color: "#666666" }}>
          5 Giugno 2026
        </p>
        <div className="gold-line mb-4" />
        <p
          className="text-xs flex items-center justify-center gap-1 mb-4"
          style={{ color: "#666666" }}
        >
          Fatto con <Heart size={12} className="text-gold" fill="#C5A572" /> per il nostro giorno speciale
        </p>
        <Link
          to="/admin"
          data-testid="footer-admin-link"
          className="inline-flex items-center gap-1 text-xs transition-colors hover:text-sage"
          style={{ color: "#AAAAAA" }}
        >
          <Lock size={10} /> Area riservata
        </Link>
      </div>
    </footer>
  );
}
